import clsx from 'clsx';

import { IButton } from '../components/buttons/DeprecatedButton';

const variantMapping = {
  borderless: 'Button--borderless',
  danger: 'Button--danger',
  light: 'Button--light',
  primary: 'Button--primary',
  important: 'Button--important',
  secondary: 'Button--secondary',
  selected: 'Button--selected',
  success: 'Button--success',
  unselected: 'Button--unselected',
};

const sizeMapping = {
  small: 'Button--small',
  medium: 'Button--medium',
  large: 'Button--large',
};

const shapeMapping = {
  rounded: 'Button--rounded',
};

export function classNameForButtonProps({
  active,
  disabled,
  modifierClassName,
  stretch,
  shape,
  size,
  variant,
}: Partial<IButton>) {
  const variantClassName = variant ? variantMapping[variant] : '';
  const sizeClassName = size ? sizeMapping[size] : '';
  const shapeClassName: string = shape ? shapeMapping[shape] : '';

  return clsx('Button', modifierClassName, variantClassName, sizeClassName, shapeClassName, {
    'Button--stretch': stretch,
    'is-active': active,
    'is-disabled': disabled,
  });
}
